import React, { JSX } from 'react';
import Style from './RssButton.module.scss';

type Props = {
  href: string;
};

const RssButton: React.FC<Props> = ({ href }): JSX.Element => {
  return (
    <a className={Style.button} href={href} target="_blank" rel="noreferrer">
      RSS
    </a>
  );
};

export default RssButton;
